import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import user from "./profile";


Vue.use(Vuex);


export default new Vuex.Store({
    modules: {
        user
        
    }
})